"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { cn } from "@/lib/utils";

function Switch({ className, ...props }: SwitchPrimitive.Root.Props) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "group relative inline-flex items-center justify-center size-10 shrink-0 cursor-pointer outline-none",
        "disabled:cursor-not-allowed disabled:opacity-40",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40",
        className,
      )}
      {...props}
    >
      <span
        aria-hidden="true"
        className={cn(
          "relative h-[18px] w-[30px] rounded-full transition-colors duration-200",
          "bg-contrast/20 group-data-[checked]:bg-primary",
        )}
      >
        <SwitchPrimitive.Thumb
          data-slot="switch-thumb"
          className={cn(
            "absolute top-[2px] left-[2px] size-[14px] rounded-full bg-white shadow-sm",
            "transition-transform duration-200 will-change-transform",
            "data-[checked]:translate-x-[12px]",
          )}
        />
      </span>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
